import { TextField, Stack, InputAdornment, Button } from "@mui/material"
import { useState } from "react"
import SearchRoundedIcon from "@mui/icons-material/SearchRounded"
import AddEvent from "../modals/AddEvent"
import DeleteEvent from "../modals/DeleteEvent"
import { getAllAdmissionEvents, getAdmissionEventFilters, getAdmissionEventSort } from "../../api"
import ListData from "../common/ListData"
import EventListCard from "../cards/EventListCard"

const Events = () => {
  const [search, setSearch] = useState("")
  const [editModal, setEditModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState(null)
  const [isEdit, setIsEdit] = useState(false)

  const handleSearchChange = (event) => setSearch(event.target.value)

  const openEditModal = (event) => {
    setSelectedEvent(event)
    setEditModal(true)
  }
  const closeEditModal = () => {
    setEditModal(false)
    setIsEdit(false)
  }
  const openDeleteModal = (event) => {
    setSelectedEvent(event)
    setDeleteModal(true)
  }
  const closeDeleteModal = () => setDeleteModal(false)

  const CTA = () => (
    <Stack direction={"row"} justifyContent="space-between" spacing={2}>
      <TextField
        value={search}
        onChange={handleSearchChange}
        placeholder="Search Events..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchRoundedIcon />
            </InputAdornment>
          ),
        }}
      />
      <Stack direction={"row"} spacing={2} alignItems="center">
        <Button onClick={() => openEditModal(null)} variant="contained">
          Add Event
        </Button>
      </Stack>
    </Stack>
  )

  return (
    <>
      <ListData
        getFilters={getAdmissionEventFilters}
        getSort={getAdmissionEventSort}
        getAllData={getAllAdmissionEvents}
        initialFilters={{}}
        HeaderRight={CTA}
        Card={EventListCard}
      />
      <AddEvent
        isOpen={editModal}
        isEdit={isEdit}
        close={closeEditModal}
        data={selectedEvent}
      />
      <DeleteEvent
        isOpen={deleteModal}
        close={closeDeleteModal}
        data={selectedEvent}
      />
    </>
  )
}

export default Events
